import React, { useCallback, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import keycloak from "../../Keycloak";
import {getHarvestTasksHoursLastMonth} from "../../utilities/harvestAPI";
import {styled} from "@mui/material/styles";
import Box from '@mui/material/Box';

const FooterFlexContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end', // Align items to the right
});

export default function StickyHeadTable({serviceRequestId}) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [hoursByTask, setHoursByTask] = useState([]);

    const fetchTaskData = useCallback(() => {
        getHarvestTasksHoursLastMonth(serviceRequestId, keycloak.token)
            .then((taskInfo) => {
                setHoursByTask(taskInfo);
                // console.log(taskInfo)
            })
            .catch(error => {
                console.error('Error fetching tasks:', error);
            });
    }, [serviceRequestId]);

    useEffect(() => {
        fetchTaskData();
    }, [fetchTaskData]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };


    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', overflowX: 'auto' }}>
                <TableContainer sx={{maxHeight: 440}}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <TableSticky>
                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            style={{
                                                fontSize: '1.2rem',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Hours by task category
                                        </Typography>
                                    </TableSticky>
                                </TableCell>
                            </TableRow>
                            {hoursByTask
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => (
                                    <TableRow hover role="checkbox" tabIndex={-1}>
                                        <TableCell>
                                            <div style={{ display: 'flex', alignItems: 'center', paddingTop: '9px', paddingBottom: '9px'}}>
                                                <div>
                                                    <Typography variant="body1">{row.taskName}</Typography>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2" color="text.secondary">
                                                {row.hours}hrs
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <FooterFlexContainer>
                {hoursByTask.length >= 5 && (
                    <TablePagination
                        sx={{
                            ".css-pdct74-MuiTablePagination-selectLabel ":{
                            },
                            ".p ":{
                                marginTop: 0,
                                marginBottom: 0
                            },
                            ".MuiTablePagination-toolbar": {
                                order: 2,
                                textAlign: "left",
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            },
                            "& .MuiTablePagination-selectLabel": {
                                order: 0
                            },
                            "& .MuiTablePagination-select": {
                                order: 1,
                                justifyContent: 'space-between',
                            },
                            "& .MuiTablePagination-displayedRows": {
                                order: 3
                            },
                            "& .MuiTablePagination-actions": {
                                order: 4
                            }
                        }}

                        rowsPerPageOptions={[5, 10, 15]}
                        component="div"
                        count={hoursByTask.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}

                    />
                )}
            </FooterFlexContainer>
        </Paper>
    );
}

const TableSticky = ({ children }) => (
    <div
        style={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
        }}
    >
        {children}
    </div>
);